import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedBusquedaCasosTareas } from "../hooks/roles/ProtectedBusquedaCasosTareas";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const BusquedaCasosTareas = React.lazy(
  () => import("../screean/services/busqueda-casos-tareas")
);
export function busquedaCasosTareas() {
  return (
    <Route
      path="/busqueda-casos-tareas"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedBusquedaCasosTareas>
              <LazySuspense>
                <BusquedaCasosTareas />
              </LazySuspense>
            </ProtectedBusquedaCasosTareas>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
